import React, { useState, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import urgentIcon from "../../../../common/assets/images/Variation 2.png";
import search_icon from "../../../../common/assets/images/search-icon-new.png";
import refreshIcon from "../../../../common/assets/images/reload.png";
import {
  Table,
  Badge,
  Pagination,
  Placeholder,
  Card,
  Form,
} from "react-bootstrap";
import { Box, Tooltip } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSort,
  faSortAmountUp,
  faSortAmountDown,
} from "@fortawesome/free-solid-svg-icons";
import LdsRoller from "../../../../utils/LdsRoller";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { toast } from "react-toastify";
import {
  // fetchAwaitingCDQs,
  fetchCodingSupport,
  fetchCodingSupportcards,
  fetchCodingSupportQueues,
  removeAwaitingCdqs,
  resetAwaitingCDQsAssginModalPayload,
  resetAwaitingCDQsFilters,
  resetCodingSupportFilters,
  updateAwaitingCDQsFilters,
  updateCodingSupportFilters,
} from "../Redux/codingSupportSlicer";
import { debounce } from "lodash";
import AwaitingCDQsFilterModal from "./AwaitingCDQsFilterModal";
import {
  setEpisodeIdentiferFilterSearch,
  setHealthFundFilterContractSearch,
  setMRNFilterSearch,
  setPriorityFilterSearch,
  setProvisionalDrgFilterSearch,
  setSpecialityFilterSearch,
  setStatusFilterSearch,
} from "../../HealthInsuranceManager/redux/HealthInformationManagerSlicer";
import AwaingtingCDQsAssignModal from "./AwaingtingCDQsAssignModal";
import CdqResponseHistoryModal from "../../CdqResponseHistoryModal/CdqResponseHistoryModal";
import { fetchCdqHistoryResponse } from "../../CoderView/redux/CoderScreenSlice";
const AwaitingCDQs = ({
  filtersPayload,
  selectedQueue,
  coderSearchTerm,
  setCoderSearchTerm,
}) => {
  const dispatch = useDispatch();

  const [selectedHcpIds, setSelectedHcpIds] = useState([]);
  const [activeDrgRow, setActiveDrgRow] = useState(null);
  const [searchType, setSearchType] = useState("episode"); // 'episode' | 'mrn'
  const [showOptions, setShowOptions] = useState(false);
  const [drgAnchorEl, setDrgAnchorEl] = useState(null);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [awaitingCDQsModal, setAwaitingCDQsModal] = useState(false);
    const [showCdqModal, setShowCdqModal] = useState(false);
     const [selectedCdqRecord, setSelectedCdqRecord] = useState(null);
      const [cdqPageNumber, setCdqPageNumber] = useState(1);
 const codebookcoblhEnv = process.env.REACT_APP_FLAG_COBLH_DEV;
  const codebookdevEnv = process.env.REACT_APP_FLAG_DEV;

  const {
    loading: codingSupportLoading,
    data: codingSupportData,
    error: codingSupportError,
  } = useSelector((state) => state.codingSupport.codingSupportData);
  const {
    loading: awaitingCDQsAssginModalLoading,
    message: awaitingCDQsAssginModalMessage,
    error: awaitingCDQsAssginModalError,
  } = useSelector(
    (state) => state.codingSupport.awaitingCDQsAssginModalResponse,
  );
  const {
    loading: cardsLoading,
    data: cardsData,
    error: cardsError,
  } = useSelector((state) => state.codingSupport.codingSupportDataCards);
    const cdqHistoryData = useSelector(
       (state) => state.coderscreenqueue.cdqHistoryData,
     );
     const loadingCdqHistoryData = useSelector(
       (state) => state.coderscreenqueue.loadingCdqHistoryData,
     );
     const errorCdqHistoryData = useSelector(
       (state) => state.coderscreenqueue.errorCdqHistoryData,
     );
  const episodes = codingSupportData?.episodes || [];
  const meta = codingSupportData?.episode_meta_data?.meta;
  // const totalPages =
  //   meta?.total_pages || Math.ceil((meta?.total_count || 0) / 10);
  const totalPages =
    meta?.total_pages ||
    Math.ceil((meta?.total_count || 0) / (filtersPayload?.page_size));

  const handleRefresh = () => {
    const CodingSupportRefreshPayload = {
      separation_date_from: null,
      separation_date_to: null,
      admission_date_from: null,
      admission_date_to: null,
      medical_record_number: [],
      speciality: [],
      queue: [selectedQueue?.queue_id] || [],
      priority: [],
      status: [],
      page_number: 1,
      page_size: 10,
      episode_identifier_search: [],
      health_fund_contract: [],
      los: [],
      los_op: null,
      drg_code: [],
      sort_by: [],
      sort_order: [],
      reasons: [],
    };
    setSelectedHcpIds([]);

    dispatch(resetCodingSupportFilters());
    setCoderSearchTerm("");
    dispatch(fetchCodingSupport(CodingSupportRefreshPayload));
    dispatch(fetchCodingSupportcards(CodingSupportRefreshPayload));
  };
   const handleViewCdqResponses = (episodeItem) => {
      setSelectedCdqRecord(episodeItem);
      setShowCdqModal(true);
      dispatch(
        fetchCdqHistoryResponse({
          hcp_line_id: episodeItem?.hcp_line_id,
          role:null,
          page_number: 1
        }),
      );
    };
   const handleCdqPageChange = (nextPage) => {
      if (nextPage < 1) return;
      setCdqPageNumber(nextPage);
      dispatch(
        fetchCdqHistoryResponse({
          hcp_line_id: selectedCdqRecord?.hcp_line_id,
           role:null,
          page_number: nextPage,
          // page_size: CDQ_PAGE_SIZE,
        }),
      );
    };
  const handleCloseCdqModal = () => {
    setShowCdqModal(false);
    setSelectedCdqRecord(null);
  };

  const handleModalClose = () => {
    setShowFilterModal(false);
    dispatch(resetCodingSupportFilters());
    dispatch(setEpisodeIdentiferFilterSearch(""));
    dispatch(setMRNFilterSearch(""));
    dispatch(setSpecialityFilterSearch(""));
    // dispatch(setQueueFilterSearch(""));
    // dispatch(setCoderFilterSearch(""));
    dispatch(setPriorityFilterSearch(""));
    dispatch(setStatusFilterSearch(""));
    dispatch(setHealthFundFilterContractSearch(""));
    dispatch(setProvisionalDrgFilterSearch(""));
    setCoderSearchTerm("");
  };
  useEffect(() => {
    if (awaitingCDQsAssginModalMessage.message) {
      toast.success(
        awaitingCDQsAssginModalMessage
          ? awaitingCDQsAssginModalMessage.message
          : "Re-assigned CDQ Episode Successfully",
      );
      const resetState = {
        separation_date_from: null,
        separation_date_to: null,
        admission_date_from: null,
        admission_date_to: null,
        medical_record_number: [],
        speciality: [],
        queue: [selectedQueue?.queue_id] || [],
        priority: [],
        status: [],
        page_number: 1,
        page_size: 10,
        episode_identifier_search: [],
        health_fund_contract: [],
        los: [],
        los_op: null,
        drg_code: [],
        sort_by: [],
        sort_order: [],
        reasons: [],
      };
      dispatch(fetchCodingSupport(resetState));
      dispatch(fetchCodingSupportcards(resetState));
      // dispatch(updateFilters(resetState));
      setSelectedHcpIds([]);
      dispatch(fetchCodingSupportQueues());
      dispatch(resetAwaitingCDQsAssginModalPayload());
      setAwaitingCDQsModal(false);
    }
    // dispatch(updateComponentState({}))
  }, [awaitingCDQsAssginModalMessage]);

  const debounceSearchHandler = useCallback(
    debounce((payload) => {
      dispatch(fetchCodingSupport(payload));
      dispatch(fetchCodingSupportcards(payload));
    }, 1000),
    [],
  );

  const handleSearch = (e) => {
    const rawValue = e.target.value;
    setCoderSearchTerm(rawValue);
    const cleanedValue = rawValue.trim().replace(/\s+/g, " ");
    setShowOptions(false);

    dispatch(
      updateCodingSupportFilters({
        ...filtersPayload,
        page_number: 1,
        episode_identifier_search: searchType === "episode" ? rawValue : "",
        medical_record_number: searchType === "mrn" ? rawValue : "",
        is_global_search: true
      }),
    );

    const apiPayload = {
      ...filtersPayload,
      page_number: 1,
      episode_identifier_search:
        searchType === "episode" && cleanedValue ? [cleanedValue] : [],
      medical_record_number:
        searchType === "mrn" && cleanedValue ? [cleanedValue] : [],
        is_global_search: true
    };
    debounceSearchHandler(apiPayload);
  };

  // Dashboard configuration
  const dashboardCards = (cardsData?.cards || []).reduce((acc, curr) => {
    Object.keys(curr || {}).forEach((key) => {
      acc[key] = (acc[key] || 0) + curr[key];
    });
    return acc;
  }, {});

  console.log(dashboardCards, "dashboardCards");
  const dashboardOptions = [
    {
      name: "Urgent",
      count: dashboardCards.urgent ?? 0,
      icon: urgentIcon,
      backgroundColor: "#FEF2F2",
    },
  ];

  const openDrgMenu = (event, hcpLineId) => {
    setDrgAnchorEl(event.currentTarget);
    setActiveDrgRow(hcpLineId);
  };
  const closeDrgMenu = () => {
    setDrgAnchorEl(null);
    setActiveDrgRow(null);
  };
  const handleSearchTypeChange = (type) => {
    setSearchType(type);
    setShowOptions(false);

    dispatch(
      updateAwaitingCDQsFilters({
        ...filtersPayload,
        episode_identifier_search: [],
        medical_record_number: [],
        page_number: 1,
      }),
    );
  };
  const handleSort = (columnKey) => {
    const currentSortBy = filtersPayload.sort_by?.[0];
    const currentSortOrder = filtersPayload.sort_order?.[0];

    let order = "asc";

    if (currentSortBy === columnKey && currentSortOrder === "asc") {
      order = "desc";
    }

    const updatedFilters = {
      ...filtersPayload,
       queue: selectedQueue?.queue_id
      ? [selectedQueue?.queue_id]
      : filtersPayload?.queue,
      sort_by: [columnKey],
      sort_order: [order],
      page_number: 1,
    };

    dispatch(updateCodingSupportFilters(updatedFilters));
    dispatch(fetchCodingSupport(updatedFilters));
    dispatch(fetchCodingSupportcards(updatedFilters));
  };
  const handlePageChange = (page) => {
    const payload = {
      ...filtersPayload,
      page_number: page,
      queue: selectedQueue?.queue_id
        ? [selectedQueue.queue_id]
        : [],
    };
  
    dispatch(updateCodingSupportFilters(payload));
    dispatch(fetchCodingSupport(payload));
    dispatch(fetchCodingSupportcards(payload));
  };
  const renderSortIcon = (columnKey) => {
    const currentSortBy = filtersPayload.sort_by?.[0];
    const currentSortOrder = filtersPayload.sort_order?.[0];

    if (currentSortBy !== columnKey) {
      return faSort; // neutral
    }

    return currentSortOrder === "asc" ? faSortAmountUp : faSortAmountDown;
  };
  const getSortTooltip = (columnKey) => {
    const currentSortBy = filtersPayload.sort_by?.[0];
    const currentSortOrder = filtersPayload.sort_order?.[0];

    if (currentSortBy !== columnKey) {
      return "Click to sort";
    }

    return currentSortOrder === "asc"
      ? "Sorted Ascending"
      : "Sorted Descending";
  };

  // const handleCDQsRowSelection = (event, HimEpisodeItem) => {
  //   // dispatch(updateComponentState(HimEpisodeItem));
  //   if (event.target.checked) {
  //     const selectedData = [...selectedHcpIds, HimEpisodeItem];
  //     setSelectedHcpIds(selectedData);
  //     // setUncheckedIds(uncheckedIds.filter(id => id !== HimEpisodeItem?.hcp_line_id));
  //   } else {
  //     const newAssignedData = selectedHcpIds.filter(
  //       (episodeId) => episodeId?.hcp_line_id !== HimEpisodeItem?.hcp_line_id,
  //     );
  //     setSelectedHcpIds(newAssignedData);
  //   }
  // };
  const handleRowsPerPageChange = (event) => {
    const payload = {
      ...filtersPayload,
      page_number: 1,
      page_size: Number(event.target.value),
      queue: selectedQueue?.queue_id ? [selectedQueue.queue_id] : [],
    };

    dispatch(updateCodingSupportFilters(payload));
    dispatch(fetchCodingSupport(payload));
    dispatch(fetchCodingSupportcards(payload));
  };

  return (
    <div className="cs-right-card">
      {/* Top Dashboard Cards */}
      <div className="cs-dashboard">
        {cardsLoading ? (
          <Placeholder
            as={Card.Text}
            animation="glow"
            style={{ width: "100%" }}
          >
            <Placeholder xs={4} className="cs-placeholder-item" />
            <Placeholder xs={4} className="cs-placeholder-item" />
            <Placeholder xs={4} className="cs-placeholder-item" />
          </Placeholder>
        ) : (
          dashboardOptions.map((item) => (
            <div
              key={item.name}
              className="cs-dashboard-card"
              style={{ backgroundColor: item.backgroundColor }}
            >
              <div className="cs-dashboard-card-top">
                <p className="cs-dashboard-card-name">{item.name}</p>
                <p className="cs-dashboard-card-icon">
                  <img src={item.icon} alt={item.name} />
                </p>
              </div>
              <p className="cs-dashboard-card-count">{item.count}</p>
            </div>
          ))
        )}
      </div>

      {/* Table Container */}
      <div className="cs-table-container">
        <div className="cs-table-header">
          <div className="cs-header-left">
            <Badge className="cs-total-count-badge cs-chip">
              Total Episodes: {meta?.total_count || 0}
            </Badge>
            {selectedHcpIds.length > 0 && (
              <Badge
                style={{ cursor: "pointer" }}
                className="workflow-him-selected-rows-count-badge him-gap cs-remove-btn cs-chip"
              onClick={async () => {
                  const count = selectedHcpIds.length;
                  try {
                    await dispatch(removeAwaitingCdqs(selectedHcpIds)).unwrap();
                  } catch (error) {
                    toast.error(
                      "Failed to remove episodes. Please try again.",
                      {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                      },
                    );
 
                    return;
                  }
                  setSelectedHcpIds([]);
                  toast.success(
                    `${count} episode${count > 1 ? "s" : ""} removed successfully!`,
                    {
                      position: "top-right",
                      autoClose: 3000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                    },
                  );
                  dispatch(
                    fetchCodingSupport({
                      ...filtersPayload,
                      queue: selectedQueue?.queue_id
                        ? [selectedQueue.queue_id]
                        : filtersPayload?.queue,
                    }),
                  );
                  dispatch(
                    fetchCodingSupportcards({
                      ...filtersPayload,
                      queue: selectedQueue?.queue_id
                        ? [selectedQueue.queue_id]
                        : filtersPayload?.queue,
                    }),
                  );
                  dispatch(fetchCodingSupportQueues());
                }}
              >
                {/* Reassign Episode */}
                Remove ({selectedHcpIds.length})
              </Badge>
            )}
          </div>

          {/* GAP */}
          <div className="cs-header-spacer" />

          {/* SEARCH */}
          <div className="cs-search-container">
            <img src={search_icon} alt="search" />
            <input
              className="cs-search-input"
              value={coderSearchTerm}
              // value={
              //   searchType === "episode"
              //     ? filtersPayload.episode_identifier_search
              //     : filtersPayload.medical_record_number
              // }
              placeholder={
                searchType === "episode"
                  ? "Search by Episode ID"
                  : "Search by MRN"
              }
              onFocus={() => setShowOptions(true)}
              onBlur={() => setTimeout(() => setShowOptions(false), 150)}
              onChange={handleSearch}
            />
            {showOptions && (
              <div className="search-options-dropdown">
                <div
                  className={`search-option ${searchType === "episode" ? "active" : ""}`}
                  onMouseDown={() => handleSearchTypeChange("episode")}
                >
                  Search by Episode ID
                </div>

                <div
                  className={`search-option ${searchType === "mrn" ? "active" : ""}`}
                  onMouseDown={() => handleSearchTypeChange("mrn")}
                >
                  Search by MRN
                </div>
              </div>
            )}
          </div>

          {/* FILTER */}
          <span
            className="cs-filter-icon"
            onClick={() => setShowFilterModal(true)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="#1f1f1f"
            >
              <path d="M440-120v-240h80v80h320v80H520v80h-80Zm-320-80v-80h240v80H120Zm160-160v-80H120v-80h160v-80h80v240h-80Zm160-80v-80h400v80H440Zm160-160v-240h80v80h160v80H680v80h-80Zm-480-80v-80h400v80H120Z" />
            </svg>
          </span>

          {/* REFRESH */}
          <div className="cs-refresh-btn" onClick={handleRefresh}>
            <img src={refreshIcon} alt="Refresh" />
          </div>
        </div>

        {/* Table Body */}
        <div className="cs-table-body">
          <Table className="cs-main-table">
            <thead className="cs-table-thead">
              <tr className="cs-table-tr">
                {/* <th className="cs-table-th"></th> */}
                <th
                  className="cs-table-th"
                  onClick={() => handleSort("episode_identifier")}
                >
                  <span>Episode Identifier</span>
                  <span className="episodelist-sort-icon">
                    <Tooltip title={getSortTooltip("episode_identifier")} arrow>
                      <span>
                        <FontAwesomeIcon
                          icon={renderSortIcon("episode_identifier")}
                        />
                      </span>
                    </Tooltip>
                  </span>
                </th>
                <th
                  className="cs-table-th"
                  onClick={() => handleSort("medical_record_number")}
                >
                  <span>MRN/UR</span>
                  <span className="episodelist-sort-icon">
                    <Tooltip
                      title={getSortTooltip("medical_record_number")}
                      arrow
                    >
                      <span>
                        <FontAwesomeIcon
                          icon={renderSortIcon("medical_record_number")}
                        />
                      </span>
                    </Tooltip>
                  </span>
                </th>
                <th
                  className="cs-table-th"
                  onClick={() => handleSort("admission_date")}
                >
                  <span>Admission Date</span>
                  <span className="episodelist-sort-icon">
                    <Tooltip title={getSortTooltip("admission_date")} arrow>
                      <span>
                        <FontAwesomeIcon
                          icon={renderSortIcon("admission_date")}
                        />
                      </span>
                    </Tooltip>
                  </span>
                </th>
                <th
                  className="cs-table-th"
                  onClick={() => handleSort("separation_date")}
                >
                  <span>Discharge Date</span>
                  <span className="episodelist-sort-icon">
                    <Tooltip title={getSortTooltip("separation_date")} arrow>
                      <span>
                        <FontAwesomeIcon
                          icon={renderSortIcon("separation_date")}
                        />
                      </span>
                    </Tooltip>
                  </span>
                </th>
                <th
                  className="cs-table-th"
                  onClick={() => handleSort("length_of_stay")}
                >
                  <span>LOS</span>
                  <span className="episodelist-sort-icon">
                    <Tooltip title={getSortTooltip("length_of_stay")} arrow>
                      <span>
                        <FontAwesomeIcon
                          icon={renderSortIcon("length_of_stay")}
                        />
                      </span>
                    </Tooltip>
                  </span>
                </th>
                <th
                  className="cs-table-th"
                  onClick={() => handleSort("speciality")}
                >
                  <span>Speciality</span>
                  <span className="episodelist-sort-icon">
                    <Tooltip title={getSortTooltip("speciality")} arrow>
                      <span>
                        <FontAwesomeIcon icon={renderSortIcon("speciality")} />
                      </span>
                    </Tooltip>
                  </span>
                </th>
                <th
                  className="cs-table-th"
                  onClick={() => handleSort("insurer_identifier")}
                >
                  <span>Health Fund Contract</span>
                  <span className="episodelist-sort-icon">
                    <Tooltip title={getSortTooltip("insurer_identifier")} arrow>
                      <span>
                        <FontAwesomeIcon
                          icon={renderSortIcon("insurer_identifier")}
                        />
                      </span>
                    </Tooltip>
                  </span>
                </th>
                <th
                  className="cs-table-th"
                  onClick={() => handleSort("drg_codes")}
                >
                  <span>Provisional DRG</span>
                  <span className="episodelist-sort-icon">
                    <Tooltip title={getSortTooltip("drg_codes")} arrow>
                      <span>
                        <FontAwesomeIcon icon={renderSortIcon("drg_codes")} />
                      </span>
                    </Tooltip>
                  </span>
                </th>
                <th
                  className="cs-table-th"
                  onClick={() => handleSort("weight")}
                >
                  <span>Provisional Account Revenue</span>
                  <span className="episodelist-sort-icon">
                    <Tooltip title={getSortTooltip("weight")} arrow>
                      <span>
                        <FontAwesomeIcon icon={renderSortIcon("weight")} />
                      </span>
                    </Tooltip>
                  </span>
                </th>
                <th className="cs-table-th" onClick={() => handleSort("reasons")}>
                  <span>Missing Notes</span>
                  <span className="episodelist-sort-icon">
                    <Tooltip title={getSortTooltip("reasons")} arrow>
                      <span>
                        <FontAwesomeIcon icon={renderSortIcon("reasons")} />
                      </span>
                    </Tooltip>
                  </span>
                </th>
                <th
                  className="cs-table-th"
                  onClick={() => handleSort("comments")}
                >
                  <span>Comments</span>
                  <span className="episodelist-sort-icon">
                    <Tooltip title={getSortTooltip("comments")} arrow>
                      <span>
                        <FontAwesomeIcon icon={renderSortIcon("comments")} />
                      </span>
                    </Tooltip>
                  </span>
                </th>
                <th
                  className="cs-table-th"
                  onClick={() => handleSort("queue_priority")}
                >
                  <span>Priority</span>
                  <span className="episodelist-sort-icon">
                    <Tooltip title={getSortTooltip("queue_priority")} arrow>
                      <span>
                        <FontAwesomeIcon
                          icon={renderSortIcon("queue_priority")}
                        />
                      </span>
                    </Tooltip>
                  </span>
                </th>
                <th
                  className="cs-table-th"
                  onClick={() => handleSort("status")}
                >
                  <span>Status</span>
                  <span className="episodelist-sort-icon">
                    <Tooltip title={getSortTooltip("status")} arrow>
                      <span>
                        <FontAwesomeIcon icon={renderSortIcon("status")} />
                      </span>
                    </Tooltip>
                  </span>
                </th>
                {!codebookcoblhEnv&&<th className="cs-table-th">Remove Awaiting CDQs</th>}
                {(codebookcoblhEnv||codebookdevEnv)&& <th className="cs-table-th">
                    <span>CDQ</span>
                  </th>}
              </tr>
            </thead>
            <tbody>
              {codingSupportLoading ? (
                <tr>
                  <td colSpan="10">
                    <div className="cs-loader-container">
                      <LdsRoller />
                    </div>
                  </td>
                </tr>
              ) : codingSupportError ? (
                <td colspan="15">
                  <div className="cs-error-container">No data found</div>
                </td>
              ) : episodes.length > 0 ? (
                episodes.map((episode) => (
                  <tr key={episode.hcp_line_id} className="cs-table-tr">
                    {/* <td className="cs-table-td">
                      <input
                        type="checkbox"
                        className="workflow-him-table-input"
                        checked={selectedHcpIds?.some(
                          (item) => item?.hcp_line_id === episode?.hcp_line_id,
                        )}
                        onChange={(e) => handleCDQsRowSelection(e, episode)}
                      />
                    </td> */}
                    <td className="cs-table-td">
                      {episode.episode_identifier}
                    </td>

                    <td className="cs-table-td">
                      <Tooltip title={episode.medical_record_number || "-"}>
                        <div className="cs-truncate-cell">
                          {episode.medical_record_number || "-"}
                        </div>
                      </Tooltip>
                    </td>
                    <td className="cs-table-td">{episode.admission_date}</td>
                    <td className="cs-table-td">{episode.separation_date}</td>
                    <td className="cs-table-td">{episode.length_of_stay}</td>
                    <td className="cs-table-td">
                      <div className="cs-specialty-cell">
                        {episode.speciality || "-"}
                      </div>
                    </td>
                    <td className="cs-table-td">
                      {episode.health_fund_contract || "-"}
                    </td>
                    <td className="cs-table-td">
                      {(() => {
                        const drgs = episode?.drg_codes || [];
                        if (!drgs.length) return "-";
                        const defaultDrg =
                          drgs.find((drg) => drg.is_default) || drgs[0];
                        const remainingDrgs = drgs.filter(
                          (drg) => drg !== defaultDrg && drg.drg_code,
                        );
                        if (!drgs?.length) return "-";
                        return (
                          <>
                            <Tooltip
                              title={
                                <>
                                  <div>
                                    <b>Grouper Version:</b>{" "}
                                    {defaultDrg.grouper_version}
                                  </div>
                                  <div>
                                    <b>Weight:</b> {defaultDrg.weight}
                                  </div>
                                </>
                              }
                              arrow
                            >
                              <span
                                style={{
                                  cursor: "pointer",
                                  fontWeight: 500,
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "2px",
                                }}
                                onClick={(e) =>
                                  openDrgMenu(e, episode.hcp_line_id)
                                }
                              >
                                {defaultDrg.drg_code}
                                {drgs?.length > 1 && (
                                  <ArrowDropDownIcon fontSize="small" />
                                )}
                              </span>
                            </Tooltip>

                            {/* Dropdown */}
                            <Menu
                              anchorEl={drgAnchorEl}
                              open={
                                Boolean(drgAnchorEl) &&
                                activeDrgRow === episode.hcp_line_id
                              }
                              onClose={closeDrgMenu}
                            >
                              {remainingDrgs.map((drg, index) => (
                                <Tooltip
                                  key={index}
                                  title={
                                    <>
                                      <div>
                                        <b>Version:</b> {drg.grouper_version}
                                      </div>
                                      <div>
                                        <b>Weight:</b> {drg.weight}
                                      </div>
                                    </>
                                  }
                                  placement="right"
                                  arrow
                                >
                                  <MenuItem
                                    onClick={() => {
                                      updateSelectedDrgIndex(
                                        episode.hcp_line_id,
                                        index,
                                      );
                                      closeDrgMenu();
                                    }}
                                  >
                                    {drg.drg_code}
                                  </MenuItem>
                                </Tooltip>
                              ))}
                            </Menu>
                          </>
                        );
                      })()}
                    </td>
                    <td className="cs-table-td">
                      {(() => {
                        const drgs = episode?.drg_codes || [];
                        if (!drgs.length) return "-";

                        const defaultDrg =
                          drgs.find((drg) => drg.is_default) || drgs[0];

                        if (!drgs?.length) return "-";

                        return (
                          <>
                            <span>
                              ${" "}
                              {Math.round(
                                defaultDrg.weight * 7258,
                              ).toLocaleString()}
                            </span>
                          </>
                        );
                      })()}
                    </td>
                    <td className="cs-table-td">
                      {(() => {
                        const reasons = episode.queue
                          ?.filter((q) => q.queue_name === "Missing notes")
                          ?.flatMap((q) => q.reasons || []);

                        return reasons?.length ? (
                          <Tooltip
                            title={
                              <div>
                                {reasons.map((r, i) => (
                                  <div key={i}>• {r.reason}</div>
                                ))}
                              </div>
                            }
                            arrow
                            placement="top"
                          >
                            <ul className="cs-bullet-list">
                              {reasons.slice(0, 2).map((r, i) => (
                                <li key={i}>{r.reason}</li>
                              ))}
                              {reasons.length > 2 && <li>…</li>}
                            </ul>
                          </Tooltip>
                        ) : (
                          "-"
                        );
                      })()}
                    </td>
                    <td className="cs-table-td">
                      {(() => {
                        const reasons = episode.queue
                          ?.filter((q) => q.queue_name === "Missing notes")
                          ?.flatMap((q) => q.reasons || []);

                        return reasons?.length ? (
                          <Tooltip
                            title={
                              <div>
                                {reasons.map((r, i) => (
                                  <div key={i}>• {r.additional_comment}</div>
                                ))}
                              </div>
                            }
                            arrow
                            placement="top"
                          >
                            <ul className="cs-bullet-list">
                              {reasons.slice(0, 2).map((r, i) => (
                                <li key={i}>{r.additional_comment}</li>
                              ))}
                              {reasons.length > 2 && <li>…</li>}
                            </ul>
                          </Tooltip>
                        ) : (
                          "-"
                        );
                      })()}
                    </td>

                                        
                      {/* Priority Column - Plain text */}
                      <td className="cs-table-td">
                        {(() => {
                          const priority = episode?.priority;

                          const priorityNames = Array.isArray(priority)
                            ? priority.filter(
                                (p) => p !== null && p !== undefined && p !== "",
                              )
                            : typeof priority === "string" && priority.trim()
                              ? [priority.trim()]
                              : [];

                          if (priorityNames.length === 0) {
                            return "-";
                          }

                          const MAX_ITEMS = 2;
                          const visibleItems = priorityNames.slice(0, MAX_ITEMS);
                          const hasMore = priorityNames.length > MAX_ITEMS;

                          return (
                            <Tooltip
                              title={
                                <div className="cs-priority-tooltip">
                                  {priorityNames.map((name, index) => (
                                    <div key={index}>• {name}</div>
                                  ))}
                                </div>
                              }
                              arrow
                              placement="top"
                            >
                              <div className="cs-priority-text">
                                {visibleItems.join(", ")}
                                {hasMore && "..."}
                              </div>
                            </Tooltip>
                          );
                        })()}
                      </td>

                    {/* Status Column - Plain text with background */}
                    {/* <td className="cs-table-td">
                      <div className="cs-status-text">
                        {episode.status || "-"}
                      </div>
                    </td> */}
                    <td className="workflow-auditor-table-td">
                      {Array.isArray(episode?.status) &&
                      episode.status.length > 0
                        ? (() => {
                            const list = episode.status.filter(
                              (s) => s?.status,
                            );
                            const topStatus = list?.filter(
                              (item) => item?.is_primary,
                            );
                            const statusText =
                              topStatus?.map((item) => item.status) ?? "-";
                            const hasMultiple = list.length > 1;
                            const getColor = (statusText) => {
                              const status = statusText[0];
                              switch (status) {
                                case "Audit - AI processing complete - codes available for validation":
                                  return "#4CAF50";
                                case "Audit - Audited":
                                  return "#2E7D32";
                                case "Audit - Awaiting Audit":
                                case "Awaiting Audit":
                                  return "#FFA726";
                                case "Audit - Awaiting CDQ":
                                  return "#FFB300";
                                case "Audit - CDQ For Review":
                                  return "#FB8C00";
                                case "Audit - Coding Complete":
                                  return "#00897B";
                                case "Audit - Locked by user":
                                  return "#757575";
                                case "Audit - Missing Notes":
                                  return "#E53935";
                                case "Audit - On Hold":
                                  return "#6A1B9A";
                                case "Audit - Outstanding":
                                  return "#F44336";
                                default:
                                  return "#344054";
                              }
                            };
                            return (
                              <Tooltip
                                title={
                                  <div style={{ padding: "4px 8px" }}>
                                    {list.map((item, index) => (
                                      <div key={index}>{item.status}</div>
                                    ))}
                                  </div>
                                }
                                arrow
                                placement="top"
                              >
                                <Box
                                  sx={{
                                    position: "relative",
                                    width: "180px",
                                    cursor: "pointer",
                                  }}
                                >
                                  {/* stacked layers */}
                                  {hasMultiple &&
                                    list.slice(1, 3).map((item, index) => (
                                      <Box
                                        key={index}
                                        sx={{
                                          position: "absolute",
                                          top: `${(index + 1) * 4}px`,
                                          left: `${(index + 1) * 4}px`,
                                          width: "100%",
                                          height: "34px",
                                          borderRadius: "6px",
                                          backgroundColor: "#E0E0E0",
                                          zIndex: index,
                                        }}
                                      />
                                    ))}

                                  {/* top status */}
                                  <Box
                                    sx={{
                                      position: "relative",
                                      zIndex: 10,
                                      backgroundColor: "#FFF",
                                      color: getColor(statusText),
                                      border: "1px solid #D0D5DD",
                                      borderRadius: "6px",
                                      fontSize: "12px",
                                      fontWeight: "600",
                                      padding: "6px 8px",
                                      textAlign: "center",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                    }}
                                  >
                                    {statusText}
                                  </Box>

                                  {/* +count badge */}
                                  {list.length > 3 && (
                                    <Box
                                      sx={{
                                        position: "absolute",
                                        bottom: "-6px",
                                        right: "-6px",
                                        background: "#344054",
                                        color: "#fff",
                                        fontSize: "10px",
                                        borderRadius: "10px",
                                        px: "5px",
                                        py: "1px",
                                      }}
                                    >
                                      +{list.length - 1}
                                    </Box>
                                  )}
                                </Box>
                              </Tooltip>
                            );
                          })()
                        : "-"}
                    </td>
                    {!codebookcoblhEnv&&<td className="cs-table-td">
                      <input
                          type="checkbox"
                          className="cs-checkbox"
                          checked={selectedHcpIds.includes(episode.hcp_line_id)}
                          onChange={(e) => {
                            const id = episode.hcp_line_id;
                            setSelectedHcpIds((prev) =>
                              e.target.checked
                                ? [...prev, id]
                                : prev.filter((x) => x !== id),
                            );
                          }}
                        />
                    </td>}
                    {(codebookcoblhEnv||codebookdevEnv)&& <td className="cs-table-td">
  {episode?.cdq_count > 0 ? (
    <span
      className="workflow-him-cdq-view"
      style={{
        color: "#175CD3",
        fontWeight: 500,
        fontSize: "13px",
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        whiteSpace: "nowrap",
      }}
      onClick={(e) => {
        e.stopPropagation();
        handleViewCdqResponses(episode);
      }}
    >
      View ({episode?.cdq_count})
    </span>
  ) : (
    "-"
  )}
                     </td>}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10">
                    <div className="cs-no-records">No records found</div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        {/* Footer / Pagination */}
        <div className="cs-table-footer">
          <div className="cs-pagination-wrapper">
            {episodes.length > 0 && (
              <Pagination className="cs-pagination">
                <Pagination.First
                  className="cs-pagination-first"
                  onClick={() => handlePageChange(1)}
                  disabled={filtersPayload.page_number <= 1}
                />
                <Pagination.Prev
                  className="cs-pagination-prev"
                  onClick={() =>
                    handlePageChange(filtersPayload.page_number - 1)
                  }
                  disabled={filtersPayload.page_number <= 1}
                />
                <Pagination.Item className="cs-pagination-item">
                  Page {filtersPayload.page_number} of {totalPages}
                </Pagination.Item>
                <Pagination.Next
                  className="cs-pagination-next"
                  onClick={() =>
                    handlePageChange(filtersPayload.page_number + 1)
                  }
                  disabled={filtersPayload.page_number >= totalPages}
                />
                <Pagination.Last
                  className="cs-pagination-last"
                  onClick={() => handlePageChange(totalPages)}
                  disabled={filtersPayload.page_number === totalPages}
                />
              </Pagination>
            )}
          </div>
          <div className="episodelist-row-options">
            <Form.Select
              className="episodelist-select"
              value={filtersPayload.page_size}
              onChange={handleRowsPerPageChange}
            >
              <option value="" disabled className="episodelist-rows-per-page">
                Rows per page
              </option>
              {/* <option value={10} className="episodelist-rows-per-page">10</option> */}
              <option value={10} className="episodelist-rows-per-page">
                10
              </option>
              <option value={50} className="episodelist-rows-per-page">
                50
              </option>
              <option value={100} className="episodelist-rows-per-page">
                100
              </option>
            </Form.Select>
          </div>
        </div>
      </div>
      {/* Modal */}
      {/* {awaitingCDQsModal && (
        <AwaingtingCDQsAssignModal
          awaitingCDQsModal={awaitingCDQsModal}
          setAwaitingCDQsModal={setAwaitingCDQsModal}
          selectedHcpIds={selectedHcpIds}
          setSelectedHcpIds={setSelectedHcpIds}
        />
      )} */}
      {/* Filter Modal */}
      <AwaitingCDQsFilterModal
        show={showFilterModal}
        setShowFilterModal={setShowFilterModal}
        onHide={handleModalClose}
        selectedQueue={selectedQueue}
        setCoderSearchTerm={setCoderSearchTerm}
      />
      <CdqResponseHistoryModal
              show={showCdqModal}
              onClose={handleCloseCdqModal}
              loading={loadingCdqHistoryData}
              error={errorCdqHistoryData}
              episodeIdentifier={selectedCdqRecord?.episode_identifier}
               totalCount={cdqHistoryData?.count_cdq_response}
                currentPage={cdqPageNumber}
                onPageChange={handleCdqPageChange}
              // onLoadMore={handleLoadMoreCdqResponses}
               responses={cdqHistoryData?.cdq_responses || []}
            />
    </div>
  );
};

export default AwaitingCDQs;
